/**
 * Normaliza una CUIT eliminando todo carácter que no sea dígito
 * (guiones, espacios, puntos). Ej.: '20-23456789-3' -> '20234567893'
 * @param {string} cuit - CUIT en cualquier formato
 * @returns {string} CUIT normalizada (solo dígitos)
 */
export const normalizarCuit = (cuit) => String(cuit || '').replace(/\D/g, '')

/**
 * Valida si la CUIT ingresada ya se encuentra asociada al usuario
 * (cuenta activa) o tiene una solicitud pendiente registrada.
 * Compara contra las cuentas/solicitudes ya cargadas en el front,
 * sin depender de una consulta al backend.
 * @param {string} cuitIngresada - CUIT ingresada en el modal (cualquier formato)
 * @param {Array} cuentas - Lista de cuentas/solicitudes del usuario (de useCuentasUsuario)
 * @param {string} cuentas[].cuit - CUIT de la cuenta (puede venir con o sin guiones)
 * @returns {boolean} true si la CUIT ya está asociada o tiene solicitud pendiente
 */
export const validarCuitDuplicada = (cuitIngresada, cuentas) => {
  const cuitNormalizada = normalizarCuit(cuitIngresada)
  if (!cuitNormalizada || !Array.isArray(cuentas)) {
    return false
  }
  return cuentas.some((cuenta) => normalizarCuit(cuenta?.cuit) === cuitNormalizada)
}
